import { IUserGuide } from "@/api/app/types/user"
import APIDashboard from "@/api/dashboard"

/*
guide step_index follows the displayed step order:

3-step guide:
| 步骤序号 | 步骤名称 |
| --- | --- |
| 1 | return_page_accessed |
| 2 | notifications_accessed |
| 3 | return_request_processed |

4-step guide:
| 步骤序号 | 步骤名称 |
| --- | --- |
| 1 | return_setting_accessed |
| 2 | return_page_accessed |
| 3 | notifications_accessed |
| 4 | return_request_processed |
*/
interface GuideStoreLike {
  data: {
    skip_onboarding?: boolean
  }
  guideData: IUserGuide
  setGuideField: (key: keyof IUserGuide, val: boolean) => void
}

export const RETURN_REQUEST_PROCESSED_KEY: keyof IUserGuide =
  "return_request_processed"

export function getGuideStepKeys(isSkip?: boolean) {
  const keys: Array<keyof IUserGuide> = []
  if (isSkip) {
    keys.push("return_setting_accessed")
  }
  keys.push(
    "return_page_accessed",
    "notifications_accessed",
    RETURN_REQUEST_PROCESSED_KEY,
  )
  return keys
}

export function getGuideCompletedCount(
  guideData: IUserGuide,
  stepKeys: Array<keyof IUserGuide>,
  key: keyof IUserGuide,
  val: boolean,
) {
  return stepKeys.filter((stepKey) =>
    stepKey === key ? val : guideData[stepKey],
  ).length
}

export function reportGuideStepComplete(
  guideData: IUserGuide,
  stepKeys: Array<keyof IUserGuide>,
  key: keyof IUserGuide,
  completedSteps: number,
) {
  const stepIndex = stepKeys.indexOf(key) + 1
  if (stepIndex <= 0) return

  console.log("complete_guide_step", {
    step_index: stepIndex,
    step_name: key,
    completed_steps: completedSteps,
    total_steps: guideData.should_finish_task_count || stepKeys.length,
  })
  window.cwreport?.report("complete_guide_step", {
    step_index: stepIndex,
    step_name: key,
    completed_steps: completedSteps,
    total_steps: guideData.should_finish_task_count || stepKeys.length,
  })
}

export function reportQuickGuideComplete(
  guideData: IUserGuide,
  stepKeys: Array<keyof IUserGuide>,
  completedSteps: number,
) {
  const shouldFinishTaskCount =
    guideData.should_finish_task_count || stepKeys.length
  const finishTaskCount = Math.max(
    guideData.finish_task_count || 0,
    completedSteps,
  )

  if (finishTaskCount >= shouldFinishTaskCount) {
    console.log("complete_quick_guide")
    window.cwreport?.report("complete_quick_guide")
  }
}

export async function completeGuideStep(
  guideStore: GuideStoreLike,
  key: keyof IUserGuide,
) {
  if (guideStore.guideData[key]) return false

  const res = await APIDashboard.saveGuide(key, true)
  const code = res?.data?.code
  if (code !== 1000) return false

  const stepKeys = getGuideStepKeys(!!guideStore.data.skip_onboarding)
  const completedSteps = getGuideCompletedCount(
    guideStore.guideData,
    stepKeys,
    key,
    true,
  )
  reportGuideStepComplete(guideStore.guideData, stepKeys, key, completedSteps)
  reportQuickGuideComplete(guideStore.guideData, stepKeys, completedSteps)
  guideStore.setGuideField(key, true)
  return true
}
